import type React from 'react';
import { useForm, Controller } from 'react-hook-form';

import RadioInput from 'components/partials/radio-input/radio-input';
import { CLIENTS_STATUSES_FORM_FIELDS as statuses } from 'containers/admin/clients/client/forms/filter-status-form/filter-status-form.constants';
import type { ClientStatusFilterValue } from 'containers/admin/clients/client/forms/filter-status-form/filter-status-form.constants';

interface FilterStatusFormProps {
  status: ClientStatusFilterValue | string;
  onClick: (value: ClientStatusFilterValue | string | undefined) => void;
}

interface FilterStatusFormValues {
  status: ClientStatusFilterValue | string;
}

const FilterStatusForm = ({
  status,
  onClick,
}: FilterStatusFormProps): React.JSX.Element => {
  const { control } = useForm<FilterStatusFormValues>({
    mode: 'onChange',
  });

  return (
    <div
      className="absolute flex items-center py-1.5"
      data-testid="filter-status-section"
    >
      <label
        htmlFor="clients-statuses"
        className="w-28 md:w-32 mr-2 md:mr-4 font-semibold text-sm md:text-base"
      >
        Filter by Status
      </label>

      <div className="flex items-center">
        <Controller
          name="status"
          control={control}
          render={({ field }) => (
            <>
              {statuses.map(
                ({ label, labelFor, valueForEdit, key, radioValue }) => (
                  <RadioInput
                    label={label}
                    labelFor={labelFor}
                    radioValue={radioValue}
                    valueForEdit={valueForEdit}
                    setAction={onClick}
                    key={key}
                    customClass="!mb-0"
                    {...field}
                    value={status}
                    data-testid={`filter-status-${labelFor}`}
                  />
                )
              )}
            </>
          )}
        />
      </div>
    </div>
  );
};

export default FilterStatusForm;
